import { createContext } from "react";

const VudioContext = createContext();

export default VudioContext;
